import { render, staticRenderFns } from "./EditCover.vue?vue&type=template&id=2acd0535&scoped=true&"
import script from "./EditCover.vue?vue&type=script&lang=js&"
export * from "./EditCover.vue?vue&type=script&lang=js&"
import style0 from "./EditCover.vue?vue&type=style&index=0&id=2acd0535&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acd0535",
  null
  
)

export default component.exports